import { ReducerAction } from 'store/modules/types';

import { Types, IRequestConsultaTransferenciaMunicipal } from './types';

export function consultaTransferenciaMunicipalRequest(
	data: IRequestConsultaTransferenciaMunicipal,
): ReducerAction {
	return {
		type: Types.CONSULTA_TRANSFERENCIA_MUNICIPAL,
		payload: data,
	};
}
export function consultaTransferenciaMunicipalSuccess(
	payload: object,
): ReducerAction {
	return {
		type: Types.CONSULTA_TRANSFERENCIA_MUNICIPAL_SUCCESS,
		payload,
	};
}
export function consultaTransferenciaMunicipalFailure(
	payload: boolean,
): ReducerAction {
	return {
		type: Types.CONSULTA_TRANSFERENCIA_MUNICIPAL_FAILURE,
		payload,
	};
}
